<template>
  <DialogRoot v-model:open="open">
    <DialogPortal>
      <DialogOverlay class="fixed inset-0 z-50 bg-black/50" />
      <DialogContent
        class="bg-base-100 fixed top-1/2 left-1/2 z-50 w-96 max-w-[90vw] -translate-x-1/2 -translate-y-1/2 rounded-lg p-6 shadow-xl"
      >
        <DialogTitle class="text-lg font-bold">{{ options?.title }}</DialogTitle>
        <DialogDescription class="py-4">{{ options?.message }}</DialogDescription>
        <div class="flex justify-end gap-2">
          <button class="btn btn-ghost" @click="cancel">
            {{ options?.cancelText ?? $t('global.cancel') }}
          </button>
          <button class="btn btn-primary" @click="confirm">
            {{ options?.confirmText ?? $t('global.confirm') }}
          </button>
        </div>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>

<script setup lang="ts">
import {
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
} from 'reka-ui';
import { useConfirmDialog } from '../../composables/dialog/useConfirmDialog';

const { open, options, confirm, cancel } = useConfirmDialog();
</script>
